import axiosInstance from '../shared/axiosInstance';
import { serviceConfig } from '../../config';
import { BookingEventHistory } from './types';

async function getBookingEventHistory(bookingId: string): Promise<BookingEventHistory> {
  const url = `${serviceConfig.endpoints.legacy.root}${serviceConfig.endpoints.legacy.customerServiceEventHistoryBooking}/${bookingId}`;
  let result = null;

  try {
    const response = await axiosInstance.get(url);
    result = response.data;
  } catch (err) {
    throw new Error('Error retriving the booking with the specified id');
  }

  return result;
}

export default getBookingEventHistory;
